import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { CustomersServices } from '../../customers/services';
import { Globals } from '../../../globals';
import { ProvidersServices } from '../../providers/services';
import { TakeawayServices } from '../../takeaway/services';
import { SearchServices } from '../../services/searchs';
import { OrdersCoServices } from '../../orders/services';
import { TPVServices } from '../../tpv/services';
import { InvoicesServices } from '../../invoices/services';
import { CustomersCreateInfoPage } from '../../customers/customers-create/customers-create-info/customers-create-info';

/**
 * Component que a traves de un array de Allergens muestra su icona
 *
 * Paso a crear:
 * Poder escoger el tamaño del icono
 */

@Component({
  selector: 'comp-searcher-customers',
  templateUrl: 'searcher-customers.html',
})
export class SearcherCustomersPage {
  @Input() form;
  @Input() og;

  keyboard: boolean = true;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public customersServices: CustomersServices,
    public globals: Globals,
    public providersServices: ProvidersServices,
    public takeawayServices: TakeawayServices,
    public searchServices: SearchServices,
    public ordersCoServices: OrdersCoServices,
    public tpvServices: TPVServices,
    public invoicesService: InvoicesServices) {

  }

  async ngOnInit() {
    this.searchServices.og = this.og;
    await this.clear();
    this.searchServices.passObservableToArray();
    this.checkIfElementHasCustomer();
  }

  selectCustomer(customer) {
    //Guardamos el form en searchService
    this.searchServices.form = this.form;
    //Seleccionamos el cliente
    this.searchServices.selectCustomer(customer);
  }

  clear() {
    //
    this.searchServices.selectedPersonId = '';
    this.searchServices.customer_data = undefined;
    this.searchServices.customer_search = '';
    this.invoicesService.customer_selected = '';
    this.searchServices.show_list = false;
    this.searchServices.searchCustomer();
    //by type
    if (this.og === 'reservation') {
      this.form.get('UID_CLIENT').setValue('');
      this.form.get('name').setValue('');
      this.form.get('email').setValue('');
      this.form.get('phone').setValue('');
      this.form.get('message').setValue('');
    } else if (this.og === 'invoices') {
      this.invoicesService.customer_selected = '';
    }
  }

  openCreateCustomer() {
    this.providersServices.quick_create = true;
    this.navCtrl.push(CustomersCreateInfoPage);
    this.searchServices.selectedPersonId = '';
    //this.customer_data = '';
    this.searchServices.customer_search = '';
    this.searchServices.searchCustomer();
  }

  async checkIfElementHasCustomer() {
    if (this.tpvServices.selected_table_tpv != undefined) {
      if (this.og === 'invoices' && this.tpvServices.selected_table_tpv.customer.name) {
        await this.selectCustomer(this.tpvServices.selected_table_tpv.customer);
      }
    }
  }

  showList() {
    this.searchServices.show_list = false;
    if (this.keyboard) {
      this.keyboard = false;
    } else {
      this.keyboard = true;
    }
  }

  async selectKeyboard() {
    //Guardamos el form en searchService
    this.searchServices.form = this.form;
    //Recuperamos el cliente
    let customer = await this.customersServices.getCustomer(this.searchServices.selectedPersonId);
    //Llenamos los inputs con los datos del cliente seleccionado
    this.searchServices.selectCustomer(customer);
  }

  onInputChange(event: Event) {
    var inputValue = (event.target as HTMLInputElement).value;
    this.form.get('UID_CLIENT').setValue('');
    this.form.get('name').setValue(inputValue);
    this.searchServices.selectedPersonId = '';
  }
}



// WEBPACK FOOTER //
// ./src/pages/components/searcher-customers/searcher-customers.ts